import React, { useEffect } from "react";
import { Link } from "react-router-dom";

import NavLight from "../../../components/navbar";
import Footer from "../../../components/footer";
import Switcher from "../../../components/switcher";

export default function SimpleStagePrivacyPolicy() {
    useEffect(() => {
        document.documentElement.setAttribute("dir", "ltr");
        document.documentElement.classList.add('dark');
        document.documentElement.classList.remove('light');
    }, []);

    const lastUpdated = "25 de junho de 2026";
    const contactEmail = "suporte@hopecreative.com.br";

    return (
        <>
            <style>{`
                @media print {
                    @page {
                        margin: 1.5cm;
                    }
                    #topnav,
                    .no-print,
                    .print-btn,
                    footer,
                    .fixed,
                    #back-to-top {
                        display: none !important;
                    }
                    #printable-section {
                        position: static !important;
                        padding: 0 !important;
                    }
                    .print-card {
                        background: #fff !important;
                        box-shadow: none !important;
                        padding: 0 !important;
                    }
                    .print-text {
                        color: #000 !important;
                    }
                    .print-heading {
                        color: #000 !important;
                    }
                    .print-link {
                        color: #000 !important;
                        text-decoration: underline !important;
                    }
                }
            `}</style>

            <NavLight />
            <section className="relative md:pt-44 pt-32 pb-8 bg-gradient-to-b from-amber-400/20 dark:from-amber-400/40 to-transparent no-print">
                <div className="container relative">
                    <div className="grid grid-cols-1 text-center mt-6">
                        <div>
                            <h5 className="md:text-4xl text-3xl md:leading-normal leading-normal tracking-wider font-semibold mb-0">Política de Privacidade - Simple Stage</h5>
                        </div>

                        <ul className="tracking-[0.5px] mb-0 inline-block mt-5 no-print">
                            <li className="inline-block capitalize font-medium duration-500 ease-in-out hover:text-amber-400"><Link to="/">Simple Stage</Link></li>
                            <li className="inline-block text-base mx-0.5 ltr:rotate-0 rtl:rotate-180"><i className="mdi mdi-chevron-right"></i></li>
                            <li className="inline-block capitalize font-medium duration-500 ease-in-out text-amber-400" aria-current="page">Política de Privacidade</li>
                        </ul>
                    </div>
                </div>
            </section>
            <section className="relative md:py-24 py-16" id="printable-section">
                <div className="container relative">
                    <div className="md:flex justify-center">
                        <div className="md:w-3/4">
                            <div id="printable">
                                <div className="p-6 bg-white dark:bg-slate-900 shadow dark:shadow-gray-800 rounded-md print-card">
                                    <p className="text-slate-400 print-text">A sua privacidade é importante para nós. Esta Política de Privacidade explica como o aplicativo Simple Stage ("nós", "nosso" ou "aplicativo") lida com as suas informações.</p>

                                    <h5 className="text-xl font-semibold mb-4 mt-8 print-heading">1. Coleta e Uso de Dados</h5>
                                    <p className="text-slate-400 print-text">O Simple Stage foi projetado para funcionar de forma totalmente offline. Nós não coletamos, armazenamos ou compartilhamos nenhum dado pessoal, informação de uso, arquivos ou repertórios inseridos por você.</p>

                                    <h5 className="text-xl font-semibold mb-4 mt-8 print-heading">2. Armazenamento Local</h5>
                                    <p className="text-slate-400 print-text">Todas as músicas, cifras, letras e setlists cadastrados no aplicativo são armazenados exclusivamente de forma local no seu próprio dispositivo. Nós não temos acesso a essas informações e elas não são enviadas para nenhum servidor externo.</p>

                                    <h5 className="text-xl font-semibold mb-4 mt-8 print-heading">3. Contas e Logins</h5>
                                    <p className="text-slate-400 print-text">O aplicativo não exige a criação de contas, não possui login e não requer conexão com a internet para suas funcionalidades principais de gerenciamento de repertório.</p>

                                    <h5 className="text-xl font-semibold mb-4 mt-8 print-heading">4. Permissões do Dispositivo</h5>
                                    <p className="text-slate-400 print-text">O aplicativo pode solicitar permissões básicas do sistema operacional apenas para o seu funcionamento adequado no dispositivo (como acesso ao armazenamento local para salvar seu banco de dados de músicas), mas não utilizamos essas permissões para transferir dados para fora do seu aparelho.</p>

                                    <h5 className="text-xl font-semibold mb-4 mt-8 print-heading">5. Mudanças nesta Política de Privacidade</h5>
                                    <p className="text-slate-400 print-text">Podemos atualizar nossa Política de Privacidade de tempos em tempos. Recomendamos que você revise esta página periodicamente para quaisquer alterações. Mudanças são efetivas imediatamente após serem publicadas nesta página.</p>

                                    <h5 className="text-xl font-semibold mb-4 mt-8 print-heading">6. Contato</h5>
                                    <p className="text-slate-400 print-text">Se você tiver alguma dúvida ou sugestão sobre nossa Política de Privacidade, não hesite em nos contatar pelo e-mail: <a href={`mailto:${contactEmail}`} className="text-amber-400 hover:text-amber-300 print-link">{contactEmail}</a>.</p>

                                    <p className="text-slate-400 mt-8 print-text">Última atualização: {lastUpdated}</p>

                                    <div className="mt-8 print-btn">
                                        <button onClick={() => window.print()} className="py-2 px-5 inline-block font-semibold tracking-wide border align-middle duration-500 text-base text-center bg-amber-400 hover:bg-amber-500 border-amber-400 hover:border-amber-500 text-white rounded-md">Imprimir</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
            <Switcher />
        </>
    )
}
